export default "__VITE_ASSET__B1Ppd50I__"